import { Tag } from '@chakra-ui/react'

export default function TutorTag(): React.ReactElement {
  return (
    <Tag fontSize="14px" bg="blue.subtle" color="blue.fg">
      TUTOR
    </Tag>
  )
}
